<template>
    <article
        v-if="showPost"
        :ref="'id-' + post.id"
        class="discussion-post__wrapper postArticle"
        :class="`postArticle--${typePost}`"
        :data-cy="post.id"
    >
        <div class="discussion-post__user">
            <ProfileCard :user="post.user" />
        </div>
        <div class="discussion-post__content">
            <!--<ReportPost :post="post" />-->
            <Post :post="post" :search-queries="searchQueries" :category-id="categoryId" :type-post="typePost" />

            <AddResponse :post="post" :is-answer-list-open="!post.isAnswerListHidden" :answer-snippet="answerSnippet" />
            <IsUseful :post="post" />
        </div>
    </article>
    <template v-if="showPost && post.answers?.length > 0">
        <div v-for="(answer, key) in post.answers" v-show="!post.isAnswerListHidden" :key="key">
            <PostArticle
                :post="answer"
                :search-queries="searchQueries"
                :type-post="'answer'"
                :answer-snippet="prepareAnswerNameSnippet(answer)"
            />
        </div>
    </template>
    <hr v-show="!$device.isDesktop && showPost && typePost !== 'answer'" class="post__hr" />
</template>

<script lang="ts">
import { PropType } from 'vue'
import PostModel from '~/models/Discussion/Post'
import Post from '~/components/objects/Discussion/Posts/Post.vue'
import ProfileCard from '~/components/objects/Discussion/Profile/ProfileCard.vue'
import IsUseful from '~/components/objects/Discussion/IsUseful.vue'
import AddResponse from '~/components/objects/Discussion/Response/AddResponse.vue'

export default {
    components: {
        ProfileCard,
        IsUseful,
        AddResponse,
        Post,
    },
    props: {
        typePost: {
            type: String,
            default: 'post',
        },
        post: {
            type: Object as PropType<PostModel>,
            default: null,
            required: true,
        },
        searchQueries: {
            type: Array,
            default: null,
        },
        categoryId: {
            type: Number,
            default: null,
        },
        answerSnippet: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            showAnswer: {
                type: Boolean,
                default: false,
            },
        }
    },
    computed: {
        showPost() {
            return (this.post.isShown && this.post.isPublished) || this.typePost === 'answer'
        },
    },
    methods: {
        prepareAnswerNameSnippet(post: PostModel) {
            if (post.user.name) {
                return `@${post.user.name}: `
            } else {
                return ''
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.discussion-post {
    &__wrapper {
        position: relative;
        margin: 1rem 0 0;
        display: grid;

        @include screen-md {
            grid-template-columns: repeat(4, 1fr);
            padding: 15px 10px;
        }
    }

    &__content {
        @include screen-md {
            grid-column: span 3;
        }
    }
}

.post {
    &__hr {
        border-top: 0 solid $color-grey-dark;
    }
}

.postArticle {
    &--answer {
        margin: 0 0 0 auto;

        @media (max-width: 768px) {
            width: 90%;
        }
    }
}
</style>
